module.exports = __webpack_public_path__ + "static/media/craig_mulry_berreda.d0de00af.jpg";